/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drawer_TitleInputs */

const en_drawer_title = /** @type {(inputs: Drawer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All plans`)
};

const id_drawer_title = /** @type {(inputs: Drawer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua rencana`)
};

/**
* | output |
* | --- |
* | "All plans" |
*
* @param {Drawer_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const drawer_title = /** @type {((inputs?: Drawer_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drawer_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_drawer_title(inputs)
	return en_drawer_title(inputs)
});